import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedModule } from '../../../shared.module';
import { debounceTime, skip } from 'rxjs';

@Component({
  selector: 'app-translation-editor',
  templateUrl: './translation-editor.component.html',
  styleUrls: ['./translation-editor.component.scss'],
  standalone: true,
  imports: [SharedModule]
})
export class TranslationEditorComponent implements OnInit {

  @Input() literals!: any;
  @Input() literalKey!: string;

  @Output() literalsChange = new EventEmitter<any>();

  form!: FormGroup;

  languages = ['ES', 'EN', 'FR', 'DE'];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.buildForm();
    this.listenChanges();
  }

  private buildForm() {
    const group: any = {};

    this.languages.forEach(lang => {
      const literal = this.getLiteralByLang(lang);
      group[lang] = [literal?.value || ''];
    });

    this.form = this.fb.group(group);
  }

  private getLiteralByLang(lang: string) {
    return this.literals?.[lang]?.find((l: any) => l.key === this.literalKey);
  }

  private listenChanges(): void {
    this.form.valueChanges
      .pipe(
      //  skip(1),
        debounceTime(300)
      )
      .subscribe(value => {
        this.save();
      });
  }

  save() {
    const updated = { ...this.literals };

    this.languages.forEach(lang => {
      const existing = this.getLiteralByLang(lang);

      if (existing) {
        existing.value = this.form.get(lang)?.value;
      } else {
        if (!updated[lang]) {
          updated[lang] = [];
        }

        updated[lang].push({
          key: this.literalKey,
          value: this.form.get(lang)?.value,
          lang
        });
      }
    });

    this.literalsChange.emit(updated);
  }
}
